import { useTranslation } from 'react-i18next';

import { NotificationMessageType } from 'types/internalNotifications';

const useNotificationMessages = () => {
  const { t } = useTranslation();

  return {
    [NotificationMessageType.NO_INTERNET]: t('notification.internal.noInternet'),
    [NotificationMessageType.EXTERNAL_RESOURCES_FAILED]: t('notification.internal.externalResourcesFailed'),
  };
};

export default useNotificationMessages;
